export type APIuuid = string;
export type APIDatetime = string;
export type APIDate = string;
export type APIEmail = string;
export type APIText = string;

export interface IAPIRelationship {
  type: string;
  id: APIuuid;
}

export interface IAPIDataObject {
  type: string;
  attributes: any;
  relationships?: { [key: string]: IAPIRelationship[] | IAPIRelationship };
  id?: APIuuid;
}

export interface IAPIErrorObject {
  status?: number;
  title?: string;
  detail?: string;
  // Extra payload some errors carry (render_error's `data`, e.g. candidate_id).
  data?: Record<string, any>;
  // Set on a duplicate-candidate error (single add: under `data`; CSV import:
  // top level) when the match is a deactivated candidate, with its identity so
  // the UI can point at the Recycle Bin entry.
  deactivated?: boolean;
  candidate_id?: string;
  candidate_email?: string;
  candidate_name?: string;
}

export interface IAPIData {
  data: IAPIDataObject;
  included?: IAPIDataObject[];
  token?: string;
}

export interface IAPIArrayData {
  data: IAPIDataObject[];
  included?: IAPIDataObject[];
  pagination?: any;
}

export abstract class APIResource {
  public id: APIuuid;
  public type: string;

  public get apiRelationship(): IAPIRelationship {
    return {
      type: this.type,
      id: this.id
    } as IAPIRelationship;
  }

  public abstract get apiData(): IAPIData;
}
